import { updateCloudflareMeta } from '@actions/app.action';
import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { COUNTRY_CODE_TO_CULTURE, CultureKeyType, DEFAULT_COORDS_BY_CULTURE, GEOLOCATION_FALLBACK_CULTURE } from '@constants/app.constants';
import { CloudflareMeta } from '@models/app.models';
import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CloudflareService {

  private store = inject(Store);
  private doc = inject(DOCUMENT);

  public updateCloudflareMeta(culture?: Observable<string | undefined>): void {
    const cfDataElement = this.doc.getElementById("cf-data");

    if (!cfDataElement) {
      this.store.dispatch(updateCloudflareMeta({meta: null}));
    }

    const ds: Record<string, string>[] =
      Object.entries(cfDataElement?.dataset ?? []).map(([key, value = '']) => ({
        key,
        value,
      }));

    const getValue = (ds: Record<string, string>[], key: string, defaultValue: string): string => {
      if (!ds) {
        return defaultValue;
      }
      const found = ds.find(item => item.key === key);
      return found ? found.value ?? defaultValue : defaultValue;
    };

    const meta: CloudflareMeta = {
      bs: Number(getValue(ds, 'bs', '')),
      city: getValue(ds, 'city', ''),
      country: getValue(ds, 'country', ''),
      latitude: Number(getValue(ds, 'latitude', '')),
      longitude: Number(getValue(ds, 'longitude', '')),
      rayid: getValue(ds, 'rayid', ''),
      timezone: getValue(ds, 'timezone', ''),
      vb: getValue(ds, 'vb', 'false') === 'true',
    };

    console.log(meta)
    if (meta.latitude === 0 || meta.longitude === 0) {
      let defaultCoords = DEFAULT_COORDS_BY_CULTURE[GEOLOCATION_FALLBACK_CULTURE];
      if (meta.country) {
        defaultCoords = DEFAULT_COORDS_BY_CULTURE[
          COUNTRY_CODE_TO_CULTURE[
            meta.country
          ] as CultureKeyType
        ];
        meta.latitude = defaultCoords.lat;
        meta.longitude = defaultCoords.lon;
        this.store.dispatch(updateCloudflareMeta({meta: meta}));
      }
      else if (culture) {
        culture.pipe(take(1)).subscribe((cultureCode) => {
          const defaultCoords =
            DEFAULT_COORDS_BY_CULTURE[cultureCode as CultureKeyType];
          meta.latitude = defaultCoords?.lat;
          meta.longitude = defaultCoords?.lon;
          this.store.dispatch(updateCloudflareMeta({ meta: meta }));
        });
      }
    }
    else {
      this.store.dispatch(
        updateCloudflareMeta({meta: meta}),
      );
    }
  }
}
